export const parsePossiblySerializedJson = (
    value: unknown,
    maxPasses = 1
): unknown => {
    let parsed = value;
    for (let i = 0; i < maxPasses; i += 1) {
        if (typeof parsed !== "string") {
            break;
        }
        const trimmed = parsed.trim();
        if (!trimmed) {
            break;
        }
        try {
            parsed = JSON.parse(trimmed);
        } catch {
            break;
        }
    }
    return parsed;
};

export const parseResponseBody = async (
    response: Response,
    options?: { maxJsonParsePasses?: number }
): Promise<unknown> => {
    const text = await response.text();
    if (!text) {
        return null;
    }
    return parsePossiblySerializedJson(text, options?.maxJsonParsePasses ?? 1);
};

export const extractErrorMessage = (payload: unknown): string | undefined => {
    if (typeof payload === "string") {
        const message = payload.trim();
        return message || undefined;
    }
    if (!payload || typeof payload !== "object") {
        return undefined;
    }

    const record = payload as Record<string, unknown>;
    const responseMessage = extractErrorMessage(record.response);
    if (responseMessage) {
        return responseMessage;
    }

    const message =
        extractErrorMessage(record.message) ||
        extractErrorMessage(record.detail) ||
        extractErrorMessage(record.error);
    if (message) {
        return message;
    }

    if (Array.isArray(record.errors) && record.errors.length > 0) {
        return extractErrorMessage(record.errors[0]);
    }

    return undefined;
};
